import type { Attrs, NodeType } from 'prosemirror-model';
import type { EditorState, NodeSelection } from 'prosemirror-state';

export const isNodeOfTypeName = (name: string) =>
  function (state: EditorState) {
    const { $from, to, node } = <NodeSelection>state.selection;
    if (node) return node.type.name === name;
    return to <= $from.end() && $from.parent.type.name === name;
  };

export const isNodeType = (type: NodeType, attrs?: Attrs) =>
  function (state: EditorState) {
    const { $from, to, node } = <NodeSelection>state.selection;
    if (node) return node.hasMarkup(type, attrs);
    return to <= $from.end() && $from.parent.hasMarkup(type, attrs);
  };
